import { atom } from 'recoil';

export const listRefreshNeededState = atom<boolean>({
  key: 'listRefreshNeededState',
  default: false,
});
